import { render, staticRenderFns } from "./ShowParticipantsTab.vue?vue&type=template&id=4fc57566&scoped=true"
import script from "./ShowParticipantsTab.vue?vue&type=script&lang=js"
export * from "./ShowParticipantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc57566",
  null
  
)

export default component.exports